@if (parentFormGroup.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label
        [class.error]="error" class="label"
        >
        {{ label ? label : 'Choose time' }}
        @if (isRequired) {
          <span>*&nbsp;</span>
          }:
        </mat-label>
      }
      @if (!isDisabled && !parentFormGroup?.controls[controlName]?.value) {
        <mat-icon
          #trigger="cdkOverlayOrigin"
          (click)="toggleOverlay()"
          cdkOverlayOrigin
          class="suffix cursor-pointer"
          matSuffix
          svgIcon="time-picker"
        ></mat-icon>
      }
      <input
        #trigger="cdkOverlayOrigin"
        (focus)="toggleOverlay()"
        [formControlName]="controlName"
        cdkOverlayOrigin
        class="input number-input"
        matInput
        placeholder="{{ placeholder }}"
        readonly
        type="text"
        />
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  }

  <ng-template
    (backdropClick)="closeOverlay()"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayHasBackdrop]="menuOpen"
    [cdkConnectedOverlayOpen]="menuOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPanelClass]="['z-1002','multiple-time-select']"
    [cdkConnectedOverlayPositions]="overlayPositions"
    cdkConnectedOverlay
    >
    <div class="custom-options rounded-[8px] bg-white border border-gray-300 shadow-md mt-[12px]">
      <div class="form-section flex-1 p-[20px] w-[450px] min-h-[150px]">
        <div
          class="time-row flex flex-row justify-center items-center w-full gap-[30px]"
          >
          <app-time-input
            [label]="fromTimeLabel"
            [parentFormGroup]="parentFormGroup"
            class="w-[50%]"
            controlName="fromTime"
            />
          <app-toggle-buttons
            [buttonLabels]="buttonLabels"
            [parentFormGroup]="parentFormGroup"
            class="time-toggle-btn w-[50%]"
            controlName="fromTimePeriod"
            />
        </div>
        <div
          class="time-row flex flex-row justify-center items-center w-full gap-[30px]"
          >
          <app-time-input
            [label]="toTimeLabel"
            [parentFormGroup]="parentFormGroup"
            class="w-[50%]"
            controlName="toTime"
            />
          <app-toggle-buttons
            [buttonLabels]="buttonLabels"
            [parentFormGroup]="parentFormGroup"
            class="time-toggle-btn w-[50%]"
            controlName="toTimePeriod"
            />

        </div>
        @if (errorMessage) {
          <div class="error-message !text-red-500 mb-2 text-type-15">
            {{ errorMessage }}
          </div>
        }
      </div>
    </div>
  </ng-template>
